// extracted by mini-css-extract-plugin
export default {"container":"Answered_container__c616o","alert":"Answered_alert__C6-yy"};